export default {
  methods: {
    emailToUsername: obj => obj.replace('@', '#').toLowerCase(),
    emailToLowercase: obj => obj.toLowerCase(),
    shortSerial: serial => {
      const regexLastDigit = /([^-]*)$/;
      const match = serial.match(regexLastDigit);
      let shortSerialCopy = match[0].match(/.{1,4}/g);
      let dividedSerial = '';
      for (let i = 0; i < shortSerialCopy.length; i++) {
        dividedSerial += shortSerialCopy[i];
        if (i < shortSerialCopy.length - 1) dividedSerial += '-';
      }
      return dividedSerial == null
        ? 'Error getting serial'
        : dividedSerial.toString().toUpperCase();
    },
    shortSerialWithoutDash: serial => {
      const regexLastDigit = /([^-]*)$/;
      const match = serial.match(regexLastDigit);
      let shortSerialCopy = match[0];
      return regexLastDigit == null
        ? 'Error getting serial'
        : shortSerialCopy.toString().toUpperCase();
    },
    showAsDecimal(number, decimals) {
      decimals = decimals || 2;
      if (isNaN(number) || !number) {
        let num = 0;
        return num.toFixed(decimals);
      }
      return number.toFixed(decimals);
    },
    showAsInt(number) {
      if (isNaN(number) || !number) {
        return 0;
      }
      return Math.ceil(number);
    },
    getCosPhi(number) {
      return this.showAsDecimal(1 - Math.abs(number - 1000) / 1000, 2);
    }
  }
};
